<template>
  <ElearningFormationPage :content="content" />
</template>

<script>
import ElearningFormationPage from "@/components/formations/ElearningFormationPage.vue";
import { elearningFormationData } from "@/components/formations/elearningFormationData";
import { useMeta } from "vue-meta";

export default {
  name: "VtcEnLigne",
  components: { ElearningFormationPage },
  setup() {
    useMeta({
      title: "Formation VTC en ligne – E-learning à 549 € | Institut Taxi",
      description: [
        {
          content:
            "Préparez votre examen VTC en ligne avec Institut Taxi. Cours, quiz, examens blancs, pratique avec véhicule et frais d'examen inclus. 549 € en 4 fois sans frais.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-vtc-en-ligne",
        },
      ],
    });

    return {
      content: elearningFormationData.vtc,
    };
  },
};
</script>
